import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Psychotherapy follow up consultation
   */
  {
    label: 'Psychotherapy follow up',
    subLabel: '(Please write your answer in the space provided)',
    field: 'psychoFollowUp',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'How have you been since your last session?',
          type: 'text',
          name: 'psychoFollowUp1'
        },
        {
          label: 'Have there been any significant changes in your life or circumstances since then?',
          type: 'text',
          name: 'psychoFollowUp2'
        },
        {
          label: 'Have you experienced any emotional triggers or stressors that influenced you since our last session?',
          type: 'text',
          name: 'psychoFollowUp3'
        },
        {
          label: 'What coping strategies have you been using when faced with difficult thoughts or situations related to your eating disorder?',
          type: 'text',
          name: 'psychoFollowUp4'
        },
        {
          label:'What progress or changes have you noticed since the last session?',
          type: 'text',
          name: 'psychoFollowUp4'
        },
        {
          label:'Are there any specific concerns or issues you would like to address in this session?',
          type: 'text',
          name: 'psychoFollowUp5'
        }
      ]
    }
  }
];

export default questionsModels;
